import { call, put } from 'redux-saga/effects';
import { fetchReturnTypesFailure, fetchReturnTypesSuccess } from '../actions';
import { ApiError } from 'store/api/types';
import { FetchReturnTypesRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { GetReturnTypesResponse, getReturnTypes } from '../api';
import { ReturnTypesData } from '../models/returnData';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* fetchReturnTypesSaga(action: FetchReturnTypesRequestAction) {
  try {
    let err: ApiError | null;
    const { connectionId } = action.payload;

    const response: GetReturnTypesResponse = yield call(
      getReturnTypes,
      connectionId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const returnTypesData: ReturnTypesData = {
      returnTypes: response.data.returnTypes,
      returnTypesEdit: response.data.returnTypesEdit,
    };

    yield put(fetchReturnTypesSuccess(returnTypesData));
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchReturnTypesFailure());
  }
}
